import React from 'react';
import Typography from '@mui/material/Typography';


import { LocalizationContext } from '../App';

const Loupe404PageComponent = () =>{
    
    return(
        <LocalizationContext.Consumer>
            { ({strings}) => 

            <div className="container padding">
                <Typography variant="h2" gutterBottom component="div" className="mb-8">
                    {strings.getString("errors.routeNotFound.title")}
                </Typography>
                <Typography variant="body1" gutterBottom component="div" className="mb-8">
                    {strings.getString("errors.routeNotFound.message")}
                </Typography>

            </div>
        }
        </LocalizationContext.Consumer>
    );
}
  
export default Loupe404PageComponent;